import React from "react"

const KlaviyoLcp14Signup = () => <div className="klaviyo-form-SiYUmy" />

export default KlaviyoLcp14Signup
